import groq from 'groq';
import { translatedFieldQuery } from '@pkg/sanity-utils/translatedFieldQuery';

export const blockTickerSectionFields = groq`
  ...,
  items[] {
    _type == 'onetime' => {
      name
    },
    _type == 'existing' => @->{
      name
    }
  },
  logos[]->{
      ...,
      ${translatedFieldQuery("partnerName")},
      ${translatedFieldQuery("partnerLogo")},
  }
`;
